import React from 'react'
import List from './List'
//import Builder from './Builder'

export default function Applications({match}) {

  /*if (match.params.id) {
    return <Builder />
  }*/

  return <List />

}